import { useState } from 'react';
import styles from './LessonRun.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import IconOutline from '@src/assets/icons/outline.svg?react';
import IconHoverOutline from '@src/assets/icons/hover_outline.svg?react';

type Props = {
  open: boolean;
  onClose: () => void;
  onContinueWithLonger: () => void;
  onContinueWithMulti: () => void;
};

function MultiLessonRunModal(props: Props) {
  const { open, onClose, onContinueWithLonger, onContinueWithMulti } = props;

  const [isYourTipHovered, setIsYourTipHovered] = useState(false);
  const [isChildTipHovered, setIsChildTipHovered] = useState(false);

  const handleCancel = () => {
    onClose();
  }

  return (
    <Modal global={false} open={open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div className={styles.mainView}>
        <div className={`${styles.header}`}>
          <div className={styles.title}>{'How will you run this Lesson?'}</div>
          <div className={styles.normalText}>Select from the following weekly class structures:</div>
        </div>
        <div className={styles.multi_content}>
          <div className={styles.subView}>
            {<div className={styles.hoverLongerView} style={{display: isYourTipHovered ? "block" : "none"}}>
              <div className={styles.hoverTipDetail}>{'Select this option if you have 30 minutes or longer for the Lesson.'}</div>
            </div>}
            <div className={`${styles.selectOptionView} ${styles.multipeViewPadding} ${isYourTipHovered ? styles.selectOptionViewHover : ''}`}>
              {<div className={styles.iconView}>
                <div className={styles.circleView} onMouseOver={() => setIsYourTipHovered(true)} onMouseLeave={() => setIsYourTipHovered(false)}>
                  <div className={styles.outlineIcon}>
                    <IconOutline />
                  </div>
                  <div className={styles.hoverOutlineIcon}>
                    <IconHoverOutline />
                  </div>
                </div>
              </div>}
              <div className={styles.lessonStart} onClick={() => onContinueWithLonger()}>
                <div className={styles.head_text}>One Longer Class</div>
                <div className={styles.footer_text}>30+ mins</div>
              </div>
            </div>
            {<div className={styles.hoverShortView} style={{display: isChildTipHovered ? "block" : "none"}}>
              <div className={styles.hoverTipDetail}>{'Select this option if you have less than 20 minutes for the Lesson.'}</div>
            </div>}
            <div className={`${styles.selectOptionView} ${styles.multipeViewPadding} ${isChildTipHovered ? styles.selectOptionViewHover : ''}`}>
              {<div className={styles.iconView}>
                <div className={styles.circleView} onMouseOver={() => setIsChildTipHovered(true)} onMouseLeave={() => setIsChildTipHovered(false)}>
                  <div className={styles.outlineIcon}>
                    <IconOutline />
                  </div>
                  <div className={styles.hoverOutlineIcon}>
                    <IconHoverOutline />
                  </div>
                </div>
              </div>}
              <div className={styles.lessonStart} onClick={() => onContinueWithMulti()}>
                <div className={styles.head_text}>Multiple Short Classes</div>
                <div className={styles.footer_text}>5 - 10 mins each</div>
              </div>
            </div>
          </div>
          <div className={styles.action}>
            <Button size="small" className={styles.cancelButton} onClick={handleCancel} label={'Cancel'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default MultiLessonRunModal;
